module.exports = __webpack_public_path__ + "static/media/odnoklassniki-square.4b842ab2.svg";